import React from 'react';
import { colourString } from '../../../library';
export function ChevronIcon(_a) {
    var _b = _a.size, size = _b === void 0 ? 20 : _b, _c = _a.tone, tone = _c === void 0 ? 'accent-3' : _c, _d = _a.rotation, rotation = _d === void 0 ? 1 : _d;
    var rotationDegrees = (rotation - 1) * 90;
    return (React.createElement("svg", { width: size, height: size, fill: "none", viewBox: "0 0 10 14", style: { transform: "rotate(".concat(rotationDegrees, "deg)") } },
        React.createElement("path", { stroke: colourString(tone), strokeLinecap: "round", strokeWidth: "3", d: "m2.35156 1.78198 5.00963 5L2.35156 11.782" })));
}
export default ChevronIcon;
